import React from 'react';
import { ModusWcIcon } from '@trimble-oss/moduswebcomponents-react';

import './icon.scss';

// Wrapper component with all types added
export const Icon: React.FC<React.ComponentProps<typeof ModusWcIcon>> = (props) => {
  return <ModusWcIcon {...props} />;
};

export default Icon;
